import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';
import { Tag } from 'primeng/tag';

import { CommonTooltipDirective } from '@app/common-modules/common-directives/components/common-tooltip.directive';
import { CommonIconPipe } from '@app/common-modules/common-icon/common-icon.pipe';
import { ScopeValueUsedInRolesRole } from '@app/common-modules/common-scope-value-used-in-roles-dialog/common-scope-value-used-in-roles-dialog.model';

@Component({
  selector: 'slnk-common-scope-value-role-item',
  templateUrl: './common-scope-value-role-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Tag, TranslatePipe, RouterLink, CommonIconPipe, CommonTooltipDirective],
})
export class CommonScopeValueRoleItemComponent {
  public readonly role = input.required<ScopeValueUsedInRolesRole>();
  public readonly canManageRoles = input.required<boolean>();
}
